import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import GeneralHtmlSupport from "@ckeditor/ckeditor5-html-support/src/generalhtmlsupport";
import Link from "@ckeditor/ckeditor5-link/src/link";
import Image from "@ckeditor/ckeditor5-image/src/image";
import InsertImage from "./plugins/InsertImage";
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';


const generalPlugins = [Essentials, GeneralHtmlSupport];

export const descriptionConfig = {
	toolbar: {
		items: ['link', 'insertImage'],
	},
	plugins: [
		...generalPlugins,
		Link, Image, InsertImage, Paragraph
	],
	htmlSupport: {
		allow: [
			{
				name: 'div',
			},
			{
				name: 'br'
			},
			{
				name: 'a',
			},
			{
				name: 'img',
			},
		],
	},
}

export const commentConfig = {
	...descriptionConfig
}

export const lyricsConfigCreate = {
	plugins: [ Essentials, Paragraph ],
	htmlSupport: {
		allow: [
			{
				name: 'p'
			},
			{
				name: 'br'
			}
		],
		disallow: [
			{
				name: 'div'
			}
		]
	},
}

export const lyricsConfig = {
	plugins: [ Essentials, GeneralHtmlSupport ],
	htmlSupport: {
		allow: [
			{
				name: 'br'
			},
			{
				name: 'span',
			}
		],
		disallow: [
			{
				name: /.*/,
			}, {
				name: 'p'
			}
		]
	},
}
